import { Badge } from "@/components/ui/badge";
import {
  getClientPlanSummary,
  PENDING_PLAN_LABEL,
  type ClientWithPlanFields,
} from "@/utils/planDisplay";

interface PlanStatusBadgeProps {
  client?: ClientWithPlanFields | null;
  className?: string;
}

export const PlanStatusBadge = ({ client, className }: PlanStatusBadgeProps) => {
  const summary = getClientPlanSummary(client);
  const isPending = summary.display_label === PENDING_PLAN_LABEL;

  return (
    <Badge
      variant={isPending ? "outline" : "secondary"}
      className={className}
    >
      {summary.display_label}
    </Badge>
  );
};
